// load scss
import './Main.scss';

// load svg sprite
import loadSpriteSvgs from './Component/Sprite/LoadSprite';
loadSpriteSvgs();

import './Component/Menu';
import './Component/Header';
import './Content/TextBox';
import './Component/Template/ePaper.js';
import './Component/HeaderVideo/HeaderVideo.js';
import './Content/TextWithImageExtended/TextWithImageExtended.js';
import './Content/TextBoxExtended/TextBoxExtended.js';
import './Content/SocialMediaFeed/SocialMediaFeed.js';
import './Content/PopUp/PopUp.js';

import './General/Accordion/Accordion';

import 'Packages/Plugins/GesagtGetan.DeepMenu/Resources/Private/Fusion/Main.js';

function handleClickableElements() {
    const elements = document.querySelectorAll('.--clickable-element');
    elements.forEach(el => {
        el.addEventListener('click', (event) => {
            if (event.target.closest('.button')) {
                return;
            }

            const link = event.currentTarget.querySelector('a.link');
            if (link) {
                window.location.href = link.href;
            }
        });
    });
}

handleClickableElements();
